import { useEffect, useMemo, useState } from 'react';
import { memberApi } from '@formosa/shared/api/member';
import {
  filterCountriesByEnNames,
  normalizeCountryList,
  pickDefaultCountry,
} from '@formosa/shared/utils/countryUtils';

export function useCountryOptions(allowedEnNames) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  const allowedKey = useMemo(() => {
    if (!Array.isArray(allowedEnNames) || allowedEnNames.length === 0) return '';
    return allowedEnNames.join('|');
  }, [allowedEnNames]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    memberApi
      .listCountries({ splitAreaCode: true })
      .then((list) => {
        if (cancelled) return;
        const normalized = normalizeCountryList(list);
        const enNameList = allowedKey ? allowedKey.split('|') : [];
        setCountries(filterCountriesByEnNames(normalized, enNameList));
      })
      .catch(() => {
        if (!cancelled) setCountries([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [allowedKey]);

  const defaultCountry = useMemo(() => pickDefaultCountry(countries), [countries]);
  return { countries, loading, defaultCountry };
}
